import Comp from './Newsletter'

export default Comp
